import { useTranslation } from 'react-i18next';

import { OppvarmingFormData } from '../../../types';

export const useFjernvarmeValidation = () => {
  const { t } = useTranslation();

  const validateFordelingssystemSelection = (_: boolean, { fjernvarme }: OppvarmingFormData) => {
    if (!fjernvarme?.value?.radiator?.selected && !fjernvarme?.value?.gulvvarme?.selected) {
      return t('form.oppvarming.common.kjel.fordelingssystem.error');
    }
    return true;
  };

  return { validateFordelingssystemSelection };
};
